import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'
import SlimSelect from "slim-select";

// Connects to data-controller="recruiter"
export default class extends Controller {
  static targets = [ "select", "name", "ucode", "email" ]

  connect() {
    this.url = '/agents/list.json'

    this.slim = new SlimSelect({
      select: this.selectTarget,
      settings: {
        placeholderText: 'Select',
      },
      events: {
        search: (search, currentData) => {
          return new Promise((resolve, reject) => {
            if (search.length < 2) {
              return reject('Search must contain at least 2 characters')
            }

            const options = this.fetchCollection(this.url, search)
            resolve(options)
          })
        },
        afterChange: (options) => {
          // console.log(options[0].value)
          const agent_url = '/agents/' + options[0].value + '.json'
          this.fetchCollection(agent_url, '')
          .then(
              (agent) => {
                // console.log(agent.full_name)
                this.nameTarget.value = agent.full_name
                this.emailTarget.value = agent.email
                this.ucodeTarget.value = agent.uni_code
                // console.log(agent)
              }
          )
        },
      }
    })
  }

  async fetchCollection(url, searchString) {
    const response = await get(url, {
      query: { q: searchString }
    })

    if (response.ok) {
      const body = await response.json
      // console.log(body)
      return body
    }
  }

  disconnect() {
    this.slim.destroy()
    super.disconnect();
  }
}
